<a (click)="viewTest()" class="{{ testResult }}">
  {{ testDate | customDate }}
</a>
